/**
 * KAN-826: name of a client company. A link to its card (/companies/<id>)
 * when the organization is known and its page is open to the user; plain
 * text otherwise (name from the row, for example the company from lead_info).
 */
import { Link } from 'react-router-dom';
import { useCanOpenPath } from '@/hooks/useApiAccess';
import type { ClientCompanyRef } from '@/types/clientCompany';

interface CompanyNameLinkProps {
  company: ClientCompanyRef | null | undefined;
  /** Text shown without an organization (and when the organization has no name). */
  fallback?: string | null;
  className?: string;
  linkClassName?: string;
}

export function CompanyNameLink({ company, fallback, className = '', linkClassName = '' }: CompanyNameLinkProps) {
  const path = company ? `/companies/${company.id}` : '';
  const canOpen = useCanOpenPath(path || '/companies');
  const name = (company?.name || '').trim() || (fallback || '').trim();
  if (!name) return null;
  if (company && canOpen) {
    return (
      <Link to={path} className={`${className} text-blue-700 hover:underline ${linkClassName}`.trim()}>
        {name}
      </Link>
    );
  }
  return <span className={className}>{name}</span>;
}
